var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenu = function SvgMenu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 7.99999C6.66634 8.73637 7.26329 9.33332 7.99967 9.33332C8.73605 9.33332 9.33301 8.73637 9.33301 7.99999C9.33301 7.26361 8.73605 6.66666 7.99967 6.66666C7.26329 6.66666 6.66634 7.26361 6.66634 7.99999Z",
    fill: "#93949A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 3.99999C6.66634 4.73637 7.26329 5.33332 7.99967 5.33332C8.73605 5.33332 9.33301 4.73637 9.33301 3.99999C9.33301 3.26361 8.73605 2.66666 7.99967 2.66666C7.26329 2.66666 6.66634 3.26361 6.66634 3.99999Z",
    fill: "#93949A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 12C6.66634 12.7364 7.26329 13.3333 7.99967 13.3333C8.73605 13.3333 9.33301 12.7364 9.33301 12C9.33301 11.2636 8.73605 10.6667 7.99967 10.6667C7.26329 10.6667 6.66634 11.2636 6.66634 12Z",
    fill: "#93949A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "menu.e8aa47776be7638e71850e0f79da0ff0.svg";